<div class="mt-2">
  <div class="row">
    <div class="col-md-10 mt-3 w-100">
      <h4 class="title"><i class="fas fa-book"></i> {{title | translate}}</h4>
    </div>
    <div class="col mt-3 content-position-end">
      <div ngbDropdown class="content-position-end text-end">
        <button class="btn btn-outline-success font-weight-bold custom-button" id="dropdownForm1" ngbDropdownToggle>
          <i class="fa fa-plus" aria-hidden="true"></i> {{ "BUTTON.MORE-ACTIONS" | translate }}
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownForm1">
          <a ngbDropdownItem class="{{isEmptySelectedList?'disabled':''}}"
             (click)="downloadMultipleDocuments()">
            <i class="fa fa-file-download"></i> {{ "BUTTON.DOWNLOAD-SIGNED-DOCUMENTS" | translate }}
          </a>
          <label class="ml-4 mb-0 font-weight-bold">{{ "BUTTON.DOWNLOAD-SIGNED-DOCUMENTS" | translate }}</label>
          <div class="custom-control custom-checkbox my-1 mr-sm-2 ml-5">
            <input type="checkbox"
                   id="stateCheckbox100"
                   name="groupRadio0"
                   class="custom-control-input"
                   [value]="myPendingState.id"
                   [checked]="wasSelected2(myPendingState)"
                   (click)="addRemoveState($event, myPendingState)"
                   [disabled]="loadingShowBy">
            <label class="custom-control-label"
                   for="stateCheckbox100">{{myPendingState.shortDescription}}</label>
          </div>
          <div *ngFor="let state of states; let index=index">
            <div
              class="custom-control custom-checkbox my-1 mr-sm-2 ml-5 {{index == 0 ? 'custom-padding-1': 'custom-padding-2'}}">
              <input type="checkbox"
                     id="stateCheckbox{{index}}"
                     name="groupRadio"
                     class="custom-control-input"
                     [value]="state.id"
                     [checked]="wasSelected2(state)"
                     (click)="addRemoveState($event, state)"
                     [disabled]="loadingShowBy">
              <label class="custom-control-label"
                     for="stateCheckbox{{index}}">{{state.shortDescription}}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row mt-2">
  <div class="col-md-3 custom-mr-17">
    <label class="font-weight-bold">{{ "LABEL.SUBJECT" | translate }}: </label>
    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text"><i class="fa fa-keyboard"></i></div>
      </div>
      <input type="text"
             id="searchInput"
             class="form-control"
             placeholder="{{ 'MESSAGE.ENTER-TO-SEARCH' | translate }}"
             [(ngModel)]="searchDocument.subject"
             (keyup.enter)="search()">
    </div>
  </div>
  <div class="col-md-2 custom-mt-24">
    <button type="button"
            class="btn btn-outline-success custom-button"
            [disabled]="searchDocument.subject === undefined || searchDocument.subject === ''"
            (click)="search()">
      <i class="fa fa-search"></i> {{ "BUTTON.SEARCH" | translate }}
    </button>
  </div>
</div>
<div class="table-responsive mt-2 mb-2 custom-table-height">
  <table class="table-sm  table-bordered">
    <thead class="custom-font-size-table-header">
    <tr>
      <th scope="col">
        <div class="custom-control custom-checkbox my-1 mr-sm-2">
          <input type="checkbox"
                 class="custom-control-input"
                 id="addRemoveAllCheckbox"
                 [checked]="wasAllSelected()"
                 (click)="addOrRemoveAll($event)">
          <label class="custom-control-label" for="addRemoveAllCheckbox"></label>
        </div>
      </th>
      <th scope="col" title="#"></th>
      <th scope="col" title="{{ 'TABLE.HEADER.ENTERPRISE' | translate }}"></th>
      <th scope="col" title="{{ 'TABLE.HEADER.FLOW' | translate }}"></th>
      <th scope="col" title="{{ 'TABLE.HEADER.SUBJECT' | translate }}"></th>
      <th scope="col" title="{{ 'TABLE.HEADER.DATE' | translate }}"></th>
      <th scope="col" title="{{ 'TABLE.HEADER.NOTES' | translate }}"></th>
      <th scope="col" title="{{ 'TABLE.HEADER.PROGRESS' | translate }}"></th>
      <th scope="col" title="{{ 'TABLE.HEADER.SIGNATORY-REVIEWER' | translate }}"></th>
      <th scope="col" title="{{ 'TABLE.HEADER.STATE' | translate }}"></th>
      <th scope="col" title="{{ 'TABLE.HEADER.ACTION' | translate }}"></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let document of documents; let index=index" class="custom-font-size-table-body">
      <td title="{{'TABLE.HEADER.SELECTED-RECORD'| translate}}">
        <div class="custom-control custom-checkbox">
          <input type="checkbox"
                 class="custom-control-input"
                 id="addRemoveCheckbox{{index}}"
                 [checked]="wasSelected(document)"
                 (click)="addOrRemove($event, document)">
          <label class="custom-control-label" for="addRemoveCheckbox{{index}}"></label>
        </div>
      </td>
      <td title="#">{{(page.number * pageNumber) + index + 1}}</td>
      <td title="{{ 'TABLE.HEADER.ENTERPRISE' | translate }}">{{document._more.enterpriseName}}</td>
      <td title="{{ 'TABLE.HEADER.FLOW' | translate }}">{{document._more.workflowDescription}}</td>
      <td title="{{ 'TABLE.HEADER.SUBJECT' | translate }}">{{document.subject}}</td>
      <td title="{{ 'TABLE.HEADER.DATE' | translate }}">{{document.createAt | dateformat}}</td>
      <td title="{{ 'TABLE.HEADER.NOTES' | translate }}">
        <span *ngIf="hasComment(document)"
              class="badge {{getBadgeTextBy(document)}}"
              data-toggle="tooltip"
              data-placement="bottom"
              title="{{wasCanceled(document) || wasModified(document) ? ('TITLE.REVIEW-THE-REASON' | translate) : ('TITLE.REVIEW-COMMENTS' | translate)}}"
              (click)="viewObservation(document)">
          {{ "BUTTON.VIEW" | translate }}
        </span>
        <span *ngIf="!hasComment(document)">-</span>
      </td>
      <td title="{{ 'TABLE.HEADER.PROGRESS' | translate }}">
        <span class="{{getSpanClass(document)}}">{{document._more.assignmentProgress}}</span>
      </td>
      <td title="{{ 'TABLE.HEADER.SIGNATORY-REVIEWER' | translate }}">
        {{document._more.fullnameNextSigner ? document._more.fullnameNextSigner : '-'}}</td>
      <td title="{{ 'TABLE.HEADER.STATE' | translate }}">
        {{document.active ? ('TABLE.HEADER.ACTIVE' | translate) : ('TABLE.HEADER.INACTIVE' | translate)}}
      </td>
      <td title="{{ 'TABLE.HEADER.ACTION' | translate }}">
        <div class="dropdown">
          <button type="button" class="btn btn-default " id="dropdownMenuButton"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="fa fa-ellipsis-v"></i>
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item pointer"
               *ngIf="true"
               (click)="view(document)">
              <i class="fa fa-eye"></i> {{ "BUTTON.VIEW-DOCUMENT" | translate }}
            </a>
            <a class="dropdown-item pointer"
               *ngIf="!wasCanceled(document) && !wasModified(document)"
               (click)="downloadOf(document)">
              <i class="fa fa-file-download"></i> {{ "BUTTON.DOWNLOAD" | translate }}
            </a>
            <a class="dropdown-item pointer"
               *ngIf="wasCanceled(document) || wasModified(document)">
              <i class="far fa-frown"></i> {{ "BUTTON.NO-OPTIONS" | translate }}
            </a>
          </div>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</div>
<nav class="Page navigation pagination-custom">
  <div class="row">
    <div class="col-md-8 mt-1">
      <div class="justify-content-row">
        <label class="mr-1 font-weight-normal">Mostrar </label>
        <select class="mr-1 br-6 form-control-sm" [(ngModel)]="pageNumber"
                (ngModelChange)="search()">
          <option *ngFor="let page of pageNumbers" [value]="page.value"
                  class="font-weight-bold">{{page.value}}</option>
        </select>
        <label class="font-weight-normal"> registros.</label>
      </div>
      <div class="page-total-entries">
        {{ "LABEL.TOTAL-RECORDS" | translate }}
        : {{documents.length + (page.number * page.size)}} {{ "LABEL.OF" | translate }} {{page.totalElements}}
      </div>
    </div>
    <div class="col-md-4">
      <ul class="pagination justify-content-end text-center">
        <li class="page-item btn-paged-ends cursor-pointer {{page.number === 0 ? 'disabled' : ''}}">
          <a class="prev {{page.number === 0 ? 'disabled' : ''}}" (click)="loadDocuments(enumPage.First)"
             tabindex="-1" aria-disabled="true">
            <i class=" fa fa-angle-double-left" aria-hidden="true"></i>
            {{ "BUTTON.FIRST" | translate }}
          </a>
        </li>
        <li class="cursor-pointer {{page.number == 0 ? 'disabled' : ''}}">
          <a class="left {{page.number == 0 ? 'disabled' : ''}}" (click)="loadDocuments(enumPage.Previous)">
            <i class="fa fa-angle-left" aria-hidden="true"></i></a>
        </li>
        <li class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}">
          <a class="right" (click)="loadDocuments(enumPage.Next)"><i
            class="fa fa-angle-right" aria-hidden="true"></i></a>
        </li>
        <li class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}">
          <a class="next" (click)="loadDocuments(enumPage.Last)">
            {{ "BUTTON.LAST" | translate }}
            <i class="fa fa-angle-double-right" aria-hidden="true"></i>
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>
<app-loading *ngIf="loading || loadingDownload"></app-loading>
